var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Bullseye } from '@patternfly/react-core/dist/dynamic/layouts/Bullseye';
import { EmptyState } from '@patternfly/react-core/dist/dynamic/components/EmptyState';
import { EmptyStateBody } from '@patternfly/react-core/dist/dynamic/components/EmptyState';
import { EmptyStateVariant } from '@patternfly/react-core/dist/dynamic/components/EmptyState';
import { Pagination } from '@patternfly/react-core/dist/dynamic/components/Pagination';
import { Table, TableBody, TableHeader } from '@patternfly/react-table/deprecated';
import { EmptyTable } from '../EmptyTable';
import { TableToolbar } from '../TableToolbar';
import { PrimaryToolbar } from '../PrimaryToolbar';
import { Skeleton } from '../Skeleton';
import { TableVariant } from '@patternfly/react-table';
import { SkeletonTable } from '@patternfly/react-component-groups';
var TableWithFilter = function (_a) {
    var _b = _a.rows, rows = _b === void 0 ? [] : _b, onSelect = _a.onSelect, _c = _a.selected, selected = _c === void 0 ? [] : _c, onUpdateData = _a.onUpdateData, pagination = _a.pagination, loaded = _a.loaded, calculateChecked = _a.calculateChecked, unique = _a.unique, filters = _a.filters, primaryToolbarProps = _a.primaryToolbarProps, children = _a.children, title = _a.title, systemName = _a.systemName, _d = _a.columns, columns = _d === void 0 ? [] : _d, tableProps = _a.tableProps, _f = _a.entityName, entityName = _f === void 0 ? 'tags' : _f, bulkSelect = _a.bulkSelect;
    var onRowSelect = function (_a) {
        var isSelected = _a.isSelected, rowId = _a.rowId;
        var currRow = rows === null || rows === void 0 ? void 0 : rows[rowId];
        if (currRow && onSelect) {
            onSelect(isSelected ? __spreadArray(__spreadArray([], selected, true), [currRow], false) : selected.filter(function (_a) {
                var id = _a.id;
                return id !== currRow.id;
            }));
        }
    };
    return (_jsxs(Fragment, { children: [onUpdateData && (_jsx(PrimaryToolbar, __assign({}, (onSelect &&
                pagination && {
                bulkSelect: __assign({ count: selected === null || selected === void 0 ? void 0 : selected.length, onSelect: function (isSelected) {
                        if (isSelected) {
                            onSelect(unique === null || unique === void 0 ? void 0 : unique(__spreadArray(__spreadArray([], rows, true), selected, true)));
                        }
                        else {
                            onSelect(selected.filter(function (_a) {
                                var id = _a.id;
                                return !rows.find(function (_a) {
                                    var rowId = _a.id;
                                    return rowId === id;
                                });
                            }));
                        }
                    }, checked: loaded && (calculateChecked === null || calculateChecked === void 0 ? void 0 : calculateChecked(rows, selected)), items: [
                        {
                            title: 'Select none (0)',
                            onClick: function () { return onSelect([]); },
                        },
                        __assign({}, (loaded && (rows === null || rows === void 0 ? void 0 : rows.length) > 0
                            ? {
                                title: "Select page (".concat(rows.length, ")"),
                                onClick: function () { return onSelect(unique === null || unique === void 0 ? void 0 : unique(__spreadArray(__spreadArray([], rows, true), selected, true))); },
                            }
                            : {})),
                    ] }, (bulkSelect || {})),
            }), (filters && {
                filterConfig: {
                    items: filters,
                },
            }), { pagination: loaded ? (__assign(__assign({}, (pagination || {})), { itemCount: pagination === null || pagination === void 0 ? void 0 : pagination.count, onSetPage: function (_e, page) { return onUpdateData(__assign(__assign({}, pagination), { page: page })); }, onPerPageSelect: function (_e, perPage) { return onUpdateData(__assign(__assign({}, pagination), { page: 1, perPage: perPage })); } })) : (_jsx(Skeleton, { size: "lg" })) }, primaryToolbarProps))), children, loaded ? (_jsxs(Table, __assign({ "aria-label": title || "".concat(systemName, " ").concat(entityName), variant: TableVariant.compact, className: "ins-c-tag-modal__table", cells: columns, rows: (rows === null || rows === void 0 ? void 0 : rows.length)
                    ? rows
                    : [
                        {
                            cells: [
                                {
                                    title: (_jsx(EmptyTable, { children: _jsx(Bullseye, { children: _jsx(EmptyState, { headingLevel: "h5", titleText: "No ".concat(entityName, " found"), variant: EmptyStateVariant.full, children: _jsxs(EmptyStateBody, { children: ["This filter criteria matches no ", entityName, ". ", _jsx("br", {}), " Try changing your filter settings."] }) }) }) })),
                                    props: {
                                        colSpan: columns.length,
                                    },
                                },
                            ],
                        },
                    ] }, (onSelect &&
                (rows === null || rows === void 0 ? void 0 : rows.length) && {
                onSelect: function (_event, isSelected, rowId) { return onRowSelect({ isSelected: isSelected, rowId: rowId }); },
            }), tableProps, { children: [_jsx(TableHeader, {}), _jsx(TableBody, {})] }))) : (_jsx(SkeletonTable, { columnsCount: columns.length, rows: (pagination === null || pagination === void 0 ? void 0 : pagination.perPage) || 10, variant: TableVariant.compact })), onUpdateData && pagination && loaded && (_jsx(TableToolbar, { isFooter: true, className: "ins-c-inventory__table--toolbar", children: _jsx(Pagination, { itemCount: pagination === null || pagination === void 0 ? void 0 : pagination.count, perPage: pagination === null || pagination === void 0 ? void 0 : pagination.perPage, page: (pagination === null || pagination === void 0 ? void 0 : pagination.page) || 0, variant: "bottom", onSetPage: function (_event, page) { return onUpdateData(__assign(__assign({}, pagination), { page: page })); }, onPerPageSelect: function (_event, perPage) { return onUpdateData(__assign(__assign({}, pagination), { page: 1, perPage: perPage })); } }) }))] }));
};
export default TableWithFilter;
//# sourceMappingURL=TableWithFilter.js.map